export default "__VITE_ASSET__Dkn9ASHL__"